<template>
  <div id="layout">
    <Header class="header" />
    <router-view />
    <SideNav class="sideNav" v-if="showNav" />
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import SideNav from "@/components/sideNav.vue";

export default {
  data() {
    return {
      showNav: false,
    };
  },
  components: { Header, Footer, SideNav },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.showNav = scrollTop > 50;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 5px;
  height: 14px;
}

::-webkit-scrollbar-thumb {
  background-color: #b6b6b6;
}
</style>
<style scoped>
.header {
  position: absolute;
  top: 0;
  z-index: 999;
  width: 100%;
}
.sideNav {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
